module.exports = __webpack_public_path__ + "img/pro_s2_icon8.f6e21f62.png";